import { FontWeights, ILabelStyles, IStackStyles } from "office-ui-fabric-react";
import { AppLayoutSettings } from "../../common/styles/common.styles";

export enum TextCliping {
  Not_Required, // no cliping required.
  Break_word, //break long text to multiple lines.
  Ellipsis //shorten the long text with three dots at end.
}

export enum TextFontStyle {
  Bold,
  Regular
}

export enum TextClick {
  Not_Required,
  Required
}

export const getLabelStyles = (fontSize: string,
  color: string, textClipingStatus: TextCliping = TextCliping.Not_Required,
  textFont: TextFontStyle = TextFontStyle.Regular, textClick = TextClick.Not_Required): ILabelStyles => {
  return {
    root: {
      whiteSpace: (textClipingStatus == TextCliping.Break_word) ? 'pre-wrap' : 'pre',
      color: color,
      fontWeight: (textFont == TextFontStyle.Regular) ? FontWeights.regular : FontWeights.semibold,
      fontSize: fontSize,
      fontFamily: "Segoe UI",
      wordBreak: (textClipingStatus == TextCliping.Break_word) ? 'break-word' : 'initial',
      overflow: (textClipingStatus == TextCliping.Ellipsis) ? 'hidden' : 'initial',
      textOverflow: (textClipingStatus == TextCliping.Ellipsis) ? 'ellipsis' : 'initial',
      cursor: (textClick == TextClick.Required) ? 'pointer' : 'default',
      textDecorationLine: (textClick == TextClick.Required) ? 'underline' : 'intial',
      selectors: (textClick == TextClick.Required) ? {
        [`:active , :hover`]: {
          fontWeight: FontWeights.bold,
        }
      } : undefined
    }
  };
}

export const getLabelContainerStyles = (margin?: string): IStackStyles => {
  return {
    root: {
      margin: margin,
      maxWidth: '100%',
    }
  };
}

export const getExtendedInfoDisplayBackgroundStyles = (marginLeft: number, marginRight: number): IStackStyles => {
  const availableSpace = window.innerWidth - marginLeft - marginRight;
  const extendedInfoDisplayWidth = availableSpace <= 0 ? window.innerWidth : availableSpace;
  return {
    root: {
      marginLeft: marginLeft,
      marginRight: marginRight,
      width: extendedInfoDisplayWidth,
      padding: '1px 1px 1px 1px',
      backgroundColor: AppLayoutSettings.getAppColorContainer().charcoalColor.value,
      position: 'absolute',
      top: "30px",
      zIndex: 1000
    }
  }
}

export const getExtendedInfoDisplayStyles = (): IStackStyles => {
  return {
    root: {
      width: '100%',
      paddingLeft: '5px',
      paddingBottom: '5px',
      backgroundColor: AppLayoutSettings.getAppColorContainer().defaultBackgroundColor.value
    }
  }
}